import { render, staticRenderFns } from "./portal-banner.vue?vue&type=template&id=51357cb5&scoped=true"
import script from "./portal-banner.vue?vue&type=script&lang=js"
export * from "./portal-banner.vue?vue&type=script&lang=js"
import style0 from "./portal-banner.vue?vue&type=style&index=0&id=51357cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51357cb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpandTransition,VIcon})
